import { render } from "./LogoutRedirect.vue?vue&type=template&id=53d2d5ff"
import script from "./LogoutRedirect.vue?vue&type=script&lang=js"
export * from "./LogoutRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__